import { createContext, ReactNode, useCallback, useContext, useState } from 'react'

import { MapAPI } from '../lib/types'

interface MapContextValue {
  mapApi: MapAPI | null
  setMapApi: (api: MapAPI | null) => void
}

const MapContext = createContext<MapContextValue | null>(null)

/**
 * Provider для Map Context
 */
export const MapProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [mapApi, setMapApiState] = useState<MapAPI | null>(null)

  const setMapApi = useCallback((api: MapAPI | null) => {
    setMapApiState(api)
  }, [])

  return <MapContext.Provider value={{ mapApi, setMapApi }}>{children}</MapContext.Provider>
}

/**
 * Hook для доступа к API карты
 *
 * @example
 * const { mapApi, isReady } = useMap()
 *
 * if (isReady) {
 *   mapApi?.addMarker('marker-1', 55.75, 37.62)
 * }
 */
export const useMap = () => {
  const context = useContext(MapContext)

  if (!context) {
    throw new Error('useMap must be used within MapProvider')
  }

  return {
    mapApi: context.mapApi,
    isReady: context.mapApi?.isReady() ?? false,
    setMapApi: context.setMapApi,
  }
}
